/* eslint-disable no-undef */
'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import _ from 'angular-mocks/ngMock';
// eslint-disable-next-line no-unused-vars
import { lookupService } from '../../../components/services/lookup/lookup.service';
import routes from './data.routes';
import uuid from 'uuid';

export class DataComponent {
  /*@ngInject*/
  constructor($http, $scope, $timeout, $location, lookup, theme, db) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$location = $location;
    this.lookup = lookup;
    this.theme = theme;
    this.$scope.type = 'allSites';
    this.$scope.allSites = [];
    this.$scope.myListParcels = [];
    this.$scope.listCount = 0;
    this.$scope.bulkIds = [];
    this.$scope.numOfBulkParcels = 0;
    this.$scope.siteStatusFilterDisabled = false;
    this.$scope.filter = {};
    this.$scope.operators = {};

    this.db = db;

    this.$scope.rowCollection = [];
    this.$scope.rowListCollection = [];

    this.$scope.filterLength = 0;

    //Function manages parcel IDs based on check box selection in data table
    $scope.updateBulkIds = function(parcel) {
      // console.log(parcel.isChecked);
      var exists = $scope.bulkIds.indexOf(parcel.parcel_id);
      if(exists > -1) {
        // console.log('exists');
        $scope.bulkIds.splice(exists, 1);
        parcel.isSelected = false;
      } else {
        // console.log('doesnt exist');
        $scope.bulkIds.push(parcel.parcel_id);
        parcel.isSelected = true;
      }

      // console.log($scope.bulkIds);
      $scope.numOfBulkParcels = $scope.bulkIds.length;

      $('#myListTabPanel').addClass('active');
      $('#myListTabNav').addClass('active');
      $('#filtersTabPanel').removeClass('active');
      $('#filtersTabNav').removeClass('active');
    };

    //Select all function selects all check boxes in current table view
    $scope.selectAll = function() {
      $('#myListTabPanel').addClass('active');
      $('#myListTabNav').addClass('active');
      $('#filtersTabPanel').removeClass('active');
      $('#filtersTabNav').removeClass('active');

      $scope.bulkIds = [];
      // console.log($scope);
      $scope.displayedCollection.forEach(element => {
        var parcel = element;
        $scope.bulkIds.push(parcel.parcel_id);
        parcel.isChecked = true;
        parcel.isSelected = true;
      });

      $scope.numOfBulkParcels = $scope.bulkIds.length;
    };

    //Function de-selects all check boxes in current view
    $scope.unselectAllParcels = function () {
      // console.log('unselecting...');
      $scope.rowCollection.forEach(element => {
        var parcel = element;
        $scope.bulkIds.forEach(element2 => {
          var parcel_id = element2;
          if(parcel_id === parcel.parcel_id) {
            console.log(parcel.parcel_id);
            parcel.isSelected = false;
            parcel.isChecked = false;
            $scope.numOfBulkParcels = 0;
            $scope.bulkIds.splice($scope.bulkIds.indexOf(parcel_id), 1);
          }
        });

        //    $scope.bulkIds = [];
      });
    };
  }

  $onInit() {
    // Add user to DB service if doesn't exist 
    if(this.db.getUser().length === 0) {
      this.$http.get('/api/users/general')
        .then(response => {
          this.db.setUser(response.data[0]);
          this.$scope.user = response.data[0];
          this.$scope.role = this.$scope.user.role;
          this.$scope.jurisdiction = this.$scope.user.Organization_Name;
          if(this.$scope.role !== 'jurisdiction') {
            this.getJurisdictions();
          }
          this.loadHessParcels();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      this.$scope.jurisdiction = this.$scope.user.Organization_Name;
      if(this.$scope.role !== 'jurisdiction') {
        this.getJurisdictions();
      }
      this.loadHessParcels();
    }

    //Load theme functions
    this.theme.initTheme();

    // Get category layers and colors [Lookup Service]
    this.$scope.hessCategoryLayers = this.lookup.getHessCategoryLayers();

    // Get list of regional zoning codes 
    this.$scope.zn_regional_codes = this.lookup.getRegionalCodes();

    this.$scope.operators.parcel_size = '>=';
    this.$scope.operators.density = '>=';
    this.$scope.operators.impr_to_land_val = '<=';
  }

  loadHessParcels(type) {
    if(type) {
      this.$scope.type = type;
    }

    if(this.$scope.type === 'allSites') {
      this.$scope.numOfBulkParcels = 0;

      if(this.$scope.allSites.length > 0) {
        this.$scope.rowCollection = this.$scope.allSites;
      } else {
        this.$scope.rowCollection = null;
        this.$http.get(`/api/data/hess/parcel/${this.$scope.type}/${this.$scope.jurisdiction}`)
          .then(response => {
            console.log(response.data);
            this.$scope.allSites = response.data;
            this.$scope.rowCollection = response.data;

            if(this.$location.search().category) {
              this.$scope.params = this.$location.search();
              this.$scope.siteStatusFilter = this.$scope.params.category;
              this.$scope.siteStatusFilterDisabled = true;
              //Use alasql to query out records matching the url parameters
              var query = "Select * FROM ? WHERE hess_color = '" + this.$scope.params.category + "'";
              this.$scope.rowCollection = alasql(query, [this.$scope.rowCollection]);

              // console.log(this.$scope.params);
              this.$scope.filterLength = 1;
              this.$location.search({});
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    } else if(this.$scope.type === 'mySites') {
      var mySitesQuery;
      console.log(this.$scope.allSites);
      if(this.$scope.allSites.length > 0) {
        mySitesQuery = "Select * FROM ? WHERE in_list = true";
        console.log('my SITES: ', alasql(mySitesQuery, [this.$scope.rowCollection]))
        this.$scope.rowCollection = alasql(mySitesQuery, [this.$scope.rowCollection]);
      } else {
        this.$scope.rowCollection = null;
        this.$http.get('/api/data/hess/parcel/' + this.$scope.type)
          .then(response => {
            console.log("main call my sites: ", response.data);
            this.$scope.rowCollection = response.data;

            if(this.$location.search().category) {
              this.$scope.params = this.$location.search();
              this.$scope.siteStatusFilter = this.$scope.params.category;
              this.$scope.siteStatusFilterDisabled = true;
              //Use alasql to query out records matching the url parameters
              mySitesQuery = "Select * FROM ? WHERE hess_color = '" + this.$scope.params.category + "'";
              this.$scope.rowCollection = alasql(mySitesQuery, [this.$scope.rowCollection]);

              // console.log(this.$scope.params);
              this.$scope.filterLength = 1;
              this.$location.search({});

              // 
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

    this.loadAllCodes();
  }

  loadAllCodes() {
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if(this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
    this.$http.get('/api/data/parcels/zncodes/' + this.$scope.jurisdiction)
      .then(response => {
        this.$scope.zn_codes = response.data;
        //Set zoning codes in lookup service
        this.lookup.setZoningCodes(response.data);
        // console.log('zn_codes', this.$scope.zn_codes);
      })
      .catch(err => {
        console.log(err);
      });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if(this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();

    // } else {
    this.$http
      .get("/api/data/parcels/gpcodes/" + this.$scope.jurisdiction)
      .then((response) => {
        this.$scope.gp_codes = response.data;
        //Set GP codes in lookup service
        this.lookup.setGPCodes(response.data);
        // console.log("gp_codes", this.$scope.gp_codes);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of use codes. If list doesn't exist in lookup service, request from server
    if(this.lookup.getUseCodes().length > 0) {
      this.$scope.use_codes = this.lookup.getUseCodes();
    } else {
      this.$http.get('/api/data/hess/parcel/uses/' + this.$scope.jurisdiction)
        .then(response => {
          this.$scope.use_codes = response.data;
          this.lookup.setUseCodes(response.data);
          // console.log('use_codes', this.$scope.use_codes);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  updateTableView(type) {
    // console.log(type);
    if(type === 'allList') {
      this.loadHessParcels();
      this.clearFilters();
    } else if(type === 'myList') {
      this.loadSiteList();
    }
  }

  //Update zoning information when zoning code is selected
  updateZnCodeInfo() {
    this.$scope.zn_codes.forEach(element => {
      if(element.zn_recid === this.$scope.hessParcel.zn_recid) {
        console.log(element);
        this.$scope.hessParcel.zn_code = element.zn_code;
        this.$scope.hessParcel.zn_description = element.zn_description;
        this.$scope.hessParcel.zn_regional_code = element.zn_regional_code;
        this.$scope.hessParcel.zn_regional_description = element.zn_regional_description;
        this.$scope.hessParcel.zn_max_dua = element.zn_max_dua;
        this.$scope.hessParcel.zn_min_dua = element.zn_min_dua;
        this.$scope.hessParcel.zn_max_height = element.zn_max_height;

        this.$scope.hessParcel.zn_units_per_lot = element.zn_units_per_lot;
        this.$scope.hessParcel.zn_max_far = element.zn_max_far;
        this.$scope.hessParcel.zn_min_lot_sqft = element.zn_min_lot_sqft;
        this.$scope.hessParcel.zn_lot_coverage_pct = element.zn_lot_coverage_pct;

        //Calculate max capacity
        if(parseFloat(element.zn_max_dua) && parseFloat(this.$scope.hessParcel.acres)) {
          this.$scope.hessParcel.max_capacity = (parseFloat(element.zn_max_dua) * parseFloat(this.$scope.hessParcel.acres)).toFixed(2);
        } else {
          this.$scope.hessParcel.max_capacity = null;
        }
      }
    });



    // console.log(this.$scope.hessParcel.parcel_id);
  }

  //Update GP information when gp code is selected
  updateGPCodeInfo() {
    this.$scope.gp_codes.forEach(element => {
      // console.log(element);
      // console.log(this.$scope.hessParcel.gp_recid);
      if(element.gp_recid === this.$scope.hessParcel.gp_recid) {
        this.$scope.hessParcel.gp_description = element.gp_description;
        this.$scope.hessParcel.gp_code = element.gp_code;
      }
    });
  }

  addSitesToList() {
    // console.log(this.$scope.bulkIds);
    this.$scope.addToSitesSpinner = true;


    this.$http.post('/api/data/hess/parcel/list/add', this.$scope.bulkIds)
      .then(response => {
        // console.log(response.data);

        this.$scope.bulkIds.forEach(element => {
          // console.log("the element: ", element)

          let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === element);
          // console.log("the update element: ", updateElement)
          updateElement.in_list = true;
          this.$scope.rowListCollection.push(updateElement);
        });


        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.addToSitesSpinner = false;

        $("#myListTabPanel").addClass("active");
        $("#myListTabNav").addClass("active");
        $("#filtersTabPanel").removeClass("active");
        $("#filtersTabNav").removeClass("active");
      })
      .catch(err => {
        console.log(err);
        this.$scope.addToSitesSpinner = false;
      });
  }

  addGreenSitesToList() {
    this.$scope.addGreenSitesSpinner = true;
    var upsertData = _.map(_.filter(this.$scope.allSites, {
      'hess_category_color': 'Green'
    }), 'parcel_id');
    // console.log(upsertData);

    this.$http.post('/api/data/hess/parcel/list/add', upsertData)
      .then(response => {
        // console.log(response.data);


        upsertData.forEach(element => {
          // console.log("the element: ", element)
          // console.log(this.$scope);
          var updateElement = _.filter(this.$scope.allSites, {
            'parcel_id': element
          });
          // console.log("the update element: ", updateElement)
          updateElement[0].in_list = true;
        });

        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.addGreenSitesSpinner = false;
        this.updateTableView('list');
      })
      .catch(err => {
        console.log(err);
        this.$scope.addGreenSitesSpinner = false;
      });
  }

  removeSitesFromList(id) {
    // console.log(this.$scope.bulkIds);
    this.$scope.removeSitesSpinner = false;
    this.$http.post('/api/data/hess/parcel/list/remove', this.$scope.bulkIds)
      .then(response => {
        // console.log(response.data);


        this.$scope.bulkIds.forEach(element => {
          let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === element);
          // console.log(updateElement);
          updateElement.in_list = false;
          this.$scope.rowCollection = this.$scope.rowCollection.filter(function (el) {
            return el.parcel_id != element;
          });
          this.$scope.allSites = this.$scope.allSites.filter(function (el) {
            return el.parcel_id != element;
          });
          this.clearFilters();
          // this.$scope.allSites = [];
        });

        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.numOfBulkParcels = 0;
        this.$scope.removeSitesSpinner = false;
      })
      .catch(err => {
        console.log(err);
        this.$scope.removeSitesSpinner = false;
      });
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table 
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  openSiteEditModal(data) {
    this.$scope.parcel_id = data.parcel_id;
    
    //Open CRUD Modal
    console.log('672. ', data);
    var queryData = {};
    this.$scope.hessParcel = {};

    this.$http.get('/api/data/hess/parcelDetails/' + data.parcel_id)
      .then(response => {
        // console.log(response.data);
        this.$scope.hessParcel = response.data[0];


        var znCodeQuery = "Select * FROM ? WHERE zn_recid = '" + response.data[0].zn_recid + "'";
        var znCode = alasql(znCodeQuery, [this.$scope.zn_codes]);


        //Populate zoning fields of modal window
        this.$scope.hessParcel.zn_units_per_lot = znCode[0].zn_units_per_lot;
        this.$scope.hessParcel.zn_description = znCode[0].zn_description;
        this.$scope.hessParcel.zn_max_height = znCode[0].zn_max_height;
        this.$scope.hessParcel.zn_max_far = znCode[0].zn_max_far;
        this.$scope.hessParcel.zn_lot_coverage_pct = znCode[0].zn_lot_coverage_pct;
        this.$scope.hessParcel.zn_min_lot_sqft = znCode[0].zn_min_lot_sqft;



        queryData = response.data[0];


        $('#siteSelectionModal').modal();
        // this.$http.get('/api/data/hess/parcel/geo/' + data.parcel_id)
        //   .then(response => {
        //     // console.log(response.data);

        //     if(this.$scope.map.getSource('zoomParcelSource')) {
        //       this.$scope.map.removeLayer('zoomParcelLayer');
        //       this.$scope.map.removeSource('zoomParcelSource');
        //     }
        //     this.$scope.map.addSource('zoomParcelSource', {
        //       'type': 'geojson',
        //       'data': {
        //         'type': 'Feature',
        //         'geometry': response.data[0].geometry
        //       }
        //     });
        //     this.$scope.map.addLayer({
        //       'id': 'zoomParcelLayer',
        //       'type': 'fill',
        //       'source': 'zoomParcelSource',
        //       'layout': {},
        //       'paint': {
        //         'fill-color': '#00fffa',
        //         'fill-opacity': 0.8
        //       }
        //     });

        //     var bbox = turf.extent(response.data[0].geometry);
        //     // console.log(bbox);
        //     this.$scope.map.fitBounds(bbox, {
        //       padding: -100
        //     });

        //   })
        //   .catch(err => {
        //     console.log(err);
        //   })
        // Resize map after modal div is fully rendered
      })
      .catch(err => {
        console.log(err);
      });
  }

  // Start update parcel function
  updateSiteData() {
    var data = this.$scope.hessParcel;


    //Add use code description based on use code
    if(data.existing_use_code && data.existing_use_code !== '') {
      var useCodeQuery = "Select * FROM ? WHERE existing_use_code = '" + data.existing_use_code + "'";
      var useCodeResult = alasql(useCodeQuery, [this.$scope.use_codes]);


      data.existing_use_description = useCodeResult.existing_use_description;
    } else {
      data.existing_use_code = null;
      data.existing_use_description = null;
    }
    // console.log("use codes: ", data.existing_use_code);
    // console.log(data.existing_use_description);

    // console.log(data);

    //test hess category calculation
    this.$http
      .post("/api/data/hess/update", data)
      .then((response) => {
        let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === response.data.parcel_id);
        
        this.$scope.hessCategoryLayers.forEach(element => {
          console.log(element);
          // console.log(element.desc + " - " + response.data.hess_category);
          if(element.desc === response.data.hess_category) {
            // console.log("should be: ", element.name);
            updateElement.hess_color = element.name;
            updateElement.hess_category = response.data.hess_category;
          } else if(response.data.hess_category === 'Parks/ROW Sites') {
            updateElement.hess_color = null;
            updateElement.hess_category = 'Parks/ROW Sites';
          }
        });
        // console.log("new hess color should be: ", updateElement);



        $("#siteSelectionModal").modal("hide");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  openFiltersModal() {
    // console.log('it was clicked');
    $('#filtersModal').modal();
  }

  updateFilters() {
    // Remove any false values from filter
    for (const key in this.$scope.filter) {
      if(this.$scope.filter.hasOwnProperty(key)) {
        if(this.$scope.filter[key] === false) {
          delete this.$scope.filter[key];
        }
      }
    }



    this.$scope.rowCollection = null;
    // console.log(this.$scope.filter);



    this.$http.post('/api/data/hess/parcels/filter/all', this.$scope.filter)
      .then(response => {
        // console.log(response.data[0]);
        // this.$scope.allSites = response.data;
        this.$scope.rowCollection = response.data;
        this.$scope.search = '';
        this.$scope.siteStatusFilter = '';
        // Update filter length 
        this.$scope.filterLength = Object.keys(this.$scope.filter).length;
        if(this.$scope.filter.impr_to_land_val_operator) {
          this.$scope.filterLength -= 1;
        }

        if(this.$scope.filter.density_operator) {
          this.$scope.filterLength -= 1;
        }

        if(this.$scope.filter.parcel_size_operator) {
          this.$scope.filterLength -= 1;
        }

        $('#filtersModal').modal('hide');
      })
      .catch(err => {
        console.log(err);
      });
  }

  clearFilters() {
    this.$scope.search = '';
    this.$scope.siteStatusFilter = '';
    this.$scope.filter = {};
    this.$scope.filterLength = 0;
    // console.log(this.$scope.allSites);
    if(this.$scope.type === 'allSites') {
      this.$scope.rowCollection = this.$scope.allSites;
    }
    this.$scope.siteStatusFilterDisabled = false;

    //Reset multi selects
    // $("#znRegionalCodeSelect").val('default');
    // $("#znRegionalCodeSelect").selectpicker("refresh");

    // $("#znCodeSelect").val('default');
    // $("#znCodeSelect").selectpicker("refresh");
  }

  getMyList() {
    this.$http.get('/api/data/hess/parcel/list')
      .then(response => {
        // console.log(response.data);
        this.$scope.myListParcels = response.data;
        this.$scope.rowListCollection = response.data;


        $("#myListTabPanel").addClass("active");
        $("#myListTabNav").addClass("active");
        $("#filtersTabPanel").removeClass("active");
        $("#filtersTabNav").removeClass("active");
      })
      .catch(err => {
        console.log(err);
      });
  }

  getJurisdictions() {
    this.$http.get('/api/data/admin/lookup/jurisdictions')
      .then(response => {
        console.log(this.$scope.user.role);
        console.log(response.data);
        console.log(response.data[0].jurisdiction.split(','));
        if(this.$scope.user.role === 'consultant') {
          var jurisdictions = response.data[0].jurisdiction.split(',');
          var jurisdictionsArray = [];
          jurisdictions.forEach(element => {
            jurisdictionsArray.push({'jurisdiction': element});
          });
          this.$scope.jurisdictions = jurisdictionsArray;
        }
        else if(this.$scope.user.role === 'admin') {
          this.$scope.jurisdictions = response.data;
        }
        console.log(this.$scope.jurisdictions);
      })
      .catch(err => {
        console.log(err);
      });
  }

  updateJurisdiction() {
    console.log(this.$scope.jurisdiction);
    this.$scope.allSites = [];
    this.$scope.rowCollection = [];
    this.loadHessParcels('allSites');
  }

  //  Parcel Notes 
  addParcelNote() {
    var recid = uuid.v1();
    console.log(this.$scope.parcel_note);
    var data = {
      recid: recid,
      note: this.$scope.parcel_note,
      parcel_id: this.$scope.parcel_id
    };

    this.$http
      .post("/api/data/hess/parcel/note/add", data)
      .then((response) => {
        console.log(response.data);
        this.$scope.parcel_note = "";
        this.$scope.parcelNotes.unshift(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getParcelNotes() {
    this.$http
      .get("/api/data/hess/notes/" + this.$scope.parcel_id )
      .then((response) => {
        this.$scope.parcelNotes = response.data;
        console.log(this.$scope.parcelNotes);
      })
      .catch((err) => {
        console.log(err);
      });
  }
}

export default angular.module('hessApp.data', [uiRouter])
  .config(routes)
  .component('data', {
    template: require('./data.html'),
    controller: DataComponent,
    controllerAs: 'dataCtrl'
  })
  /** 
   * @desc Directive managing clear filters function
   */
  .directive("stResetSearch", function () {
    return {
      restrict: 'EA',
      require: '^stTable',
      link: function (scope, element, attrs, ctrl) {
        return element.bind('click', function () {
          return scope.$apply(function () {
            var tableState;
            tableState = ctrl.tableState();
            tableState.search.predicateObject = {};
            tableState.pagination.start = 0;
            return ctrl.pipe();
          });
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/data/data.component.js